import makeStyles from "@material-ui/core/styles/makeStyles"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import AnnexItem, { formatSize } from "./AnnexItem"
import React, { Fragment, useEffect, useState } from "react"
import { CustomFile, useFilesManage, useSelectFiles, useUpload } from "./hooks/upload"
import { Annex } from "Types/material"

const useStyles = makeStyles({
    root: {
        width: "100%",
        marginTop: 12,
        marginBottom: 12,
    },
    imageIcon: {
        width: 20,
        height: "auto",
    },
    content: {
        width: "100%",
        marginTop: 12,
        marginBottom: 12,
        maxHeight: 200,
        overflowY: "scroll",
        padding: 20,
    },
})

interface ComponentProps {
    fieldName: string,
    onConfirm: (fieldName: string, annex: any) => void,
    initialAnnex?: any,
    disabled?: boolean,
}
// 上传多个annex
export default (props: ComponentProps) => {
    const classes = useStyles()
    const { onConfirm, fieldName, initialAnnex, disabled = false } = props
    const [ initialAnnexes, setInitialAnnexes ] = useState(initialAnnex)
    const { files, handleSelectFiles, handleRemoveFile, handleChangeFile } = useSelectFiles()
    const { percent, upload } = useUpload()
    const {
        currentUpload,
        uploadedFiles,
        totalSize,
    } = useFilesManage(files, upload, handleChangeFile, handleRemoveFile)
    useEffect(() => {
        const annexes = uploadedFiles.map((file: CustomFile) => {
            const { name, size, url, type } = file
            return { name, file_size: size, url, content_type: type }
        })
        onConfirm(fieldName, initialAnnexes.concat(annexes))
        // eslint-disable-next-line
    }, [uploadedFiles, initialAnnexes])
    return (
        <div className={classes.root}>
            <Grid container spacing={1} alignItems="center" justify="flex-start">
                <Grid item>
                    <img
                        className={classes.imageIcon}
                        src="http://1-im.guokr.com/i1-Dx_Li6_vnS0xVFuO0dTPA2RSXBBclzpJPqYZFSdDIAAAAyAAAAFBO.png"
                        alt="附件"
                    />
                </Grid>
                {
                    !disabled && (
                        <Fragment>
                            <Grid item>
                                <Button onClick={handleSelectFiles}>添加附件</Button>
                            </Grid>
                            <Grid item>
                                <Typography color="textSecondary" variant="body2">
                                    {`(已成功上传${uploadedFiles.length}个附件，共${formatSize(totalSize)}`}
                                </Typography>
                            </Grid>
                        </Fragment>
                    )
                }
            </Grid>
            <div className={classes.content}>
                <Grid container spacing={3}>
                    {
                        initialAnnexes.map((file: Annex, index: number) => (
                            <AnnexItem
                                content_type={file.content_type}
                                name={file.name}
                                url={file.url}
                                file_size={file.file_size}
                                uploaded={true}
                                isUploading={false}
                                disabled={disabled}
                                onRemove={() => {
                                    initialAnnexes.splice(index, 1)
                                    setInitialAnnexes([...initialAnnexes])
                                }}
                            />
                        ))
                    }
                    { files.map((file: CustomFile, index: number) => (
                        <AnnexItem
                            content_type={file.type}
                            name={file.name}
                            url={file.url}
                            file_size={file.size}
                            uploaded={file.uploaded}
                            disabled={disabled}
                            onRemove={() => {
                                handleRemoveFile(index)
                            }}
                            isUploading={currentUpload === index}
                            percent={percent}
                            status={file.status}
                        />
                    ))}
                </Grid>
            </div>
        </div>
    )
}
